/**
 * App runtime bootstrap (main thread). Installs the real geocoder seam and initialises the
 * ephemeris for any main-thread chart math (the worker initialises its own copy). Call
 * `bootstrapRuntime()` once before rendering.
 */

import { initEphemeris } from "./astro/ephemeris";
import { set_geocoder } from "./lib/event_intake";
import { default_geocoder } from "./lib/geocoding";

let started: Promise<void> | null = null;

export function bootstrapRuntime(): Promise<void> {
  if (started === null) {
    set_geocoder(default_geocoder);
    started = initEphemeris().then(() => undefined);
  }
  return started;
}
